{
  "titles": {
    "join": "Beitreten: {{fboName}}",
    "invalidInvite": "Ungültige Einladung"
  },
  "messages": {
    "joinQuestion": "Möchtest du {{fboName}} auf AirPlx beitreten?",
    "alreadyClaimed": "Du hast deine Einladung bereits eingelöst. Du kannst jetzt auf dein Konto unter app.airplx.com zugreifen. Wir empfehlen dir, den Link in deinem Browser als Lesezeichen zu speichern, um künftig schnell darauf zugreifen zu können."
  },
  "buttons": {
    "no": "Nein",
    "yes": "Ja",
    "ok": "Ok"
  }
}
